/* eslint-disable jira/filename-case */
export const ASC = 'ASC' as const;
export const DESC = 'DESC' as const;

export type SortDirection = typeof ASC | typeof DESC;
